import { tourStorageKey, type TourPersona, type TourProgress } from '@fsv/data';
import { startDemo } from '../auth/sessionStore';
import { demoHomePath } from '../lib/demoEntry';

/**
 * The tour with the demo data, started from a real session (the welcome, the
 * profile, the help). It is the demo exactly as `/demo/…` opens it — its own
 * store, no network — with the persona's tour set to the first step, so it
 * runs even for somebody who finished it before. The real session's token is
 * not touched; "Zurück zu meinem Verein" in the demo band returns to it
 * (`endDemo`). Answers the path to open.
 */
export function startTourWithDemoData(persona: TourPersona): string {
  const first: TourProgress = { status: 'running', step: 0 };
  try {
    window.localStorage.setItem(tourStorageKey(persona), JSON.stringify(first));
  } catch {
    /* private mode: the tour still starts by itself for a persona never opened in this tab */
  }
  startDemo(persona);
  return demoHomePath();
}
